import { withRequiredPermissions } from '@/lib/permissions'
import { JobPhotoReport } from '@eigtech/ui-shared-jobs-web'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ROUTER_PATHS } from '../../../../../lib/constants'

const JobDetailPhotoReport = withRequiredPermissions(JobDetailPhotoReportComponent, {
  requiredPermissions: [
    { action: 'read', subject: 'document' },
    { action: 'create', subject: 'document' },
  ],
})

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/photo-report')({
  component: JobDetailPhotoReport,
})

function JobDetailPhotoReportComponent() {
  const { jobId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <JobPhotoReport
      jobId={jobId}
      onSubmitted={() =>
        navigate({
          to: ROUTER_PATHS.jobDetailPhotoReportStatus.route,
          params: { jobId },
        })
      }
    />
  )
}
